export const DUREE_PRESETS = [30, 45, 60, 75, 90, 120, 150, 180];

/** Durées réellement proposées sur le site (voir resolveDureesAutorisees). */
export const resolveDureesAutorisees = (commercant, prestation) => {
  const fromPrestation = normalizeList(prestation?.dureesAutoriseesMinutes);
  if (fromPrestation.length) return fromPrestation;
  const defautPrestation = parseInt(prestation?.dureeMinutes, 10);
  if (Number.isFinite(defautPrestation) && defautPrestation >= 15) {
    return [defautPrestation];
  }
  const fromCommercant = normalizeList(commercant?.dureesAutoriseesMinutes);
  if (fromCommercant.length) return fromCommercant;
  const defaut = parseInt(commercant?.dureeCreneauDefaut, 10) || 60;
  return [defaut];
};

export const describeDureesSite = (commercant, prestationForm) => {
  const fromPrestation = normalizeList(prestationForm?.dureesAutoriseesMinutes);
  if (fromPrestation.length) {
    return { list: fromPrestation, label: 'Durées pour cette prestation (site)' };
  }
  const defaut = parseInt(prestationForm?.dureeMinutes, 10) || 60;
  const fromShop = normalizeList(commercant?.dureesAutoriseesMinutes);
  if (fromShop.length) {
    return {
      list: [defaut],
      label: 'Site : durée par défaut seule',
      hint: `Pour proposer ${fromShop.join(', ')} min, cochez les durées ci-dessus.`,
    };
  }
  return { list: [defaut], label: 'Site : durée par défaut seule (60 min si non renseigné)' };
};

export const roundMoney = (value) => {
  const n = parseFloat(value);
  if (Number.isNaN(n)) return null;
  return Math.round((n + Number.EPSILON) * 100) / 100;
};

export const normalizeList = (values) => {
  if (!Array.isArray(values)) return [];
  return [...new Set(values.map((v) => parseInt(v, 10)).filter((n) => n >= 15 && n <= 480))].sort((a, b) => a - b);
};

export const resolvePrixPourDuree = (prestation, minutes) => {
  const duree = parseInt(minutes, 10);
  const tarifs = parseTarifs(prestation?.tarifsDuree);
  const match = tarifs.find((t) => t.minutes === duree);
  if (match) return match.prix;
  const base = Number(prestation?.prix) || 0;
  const baseDuree = Math.max(1, parseInt(prestation?.dureeMinutes, 10) || 60);
  return Number(((base * duree) / baseDuree).toFixed(2));
};

export const parseTarifs = (raw) => {
  if (!raw) return [];
  const list = typeof raw === 'string' ? JSON.parse(raw) : raw;
  if (!Array.isArray(list)) return [];
  return list
    .map((e) => ({ minutes: parseInt(e.minutes, 10), prix: parseFloat(e.prix) }))
    .filter((e) => e.minutes > 0 && !Number.isNaN(e.prix));
};

export const isModuleCreneauxActif = (commercant) =>
  Boolean(commercant?.moduleCreneaux || commercant?.priseCreneaux);
